export default __webpack_public_path__ + "src/images/home/Life with Beth and Court-5cf9e12359a6d284ef3bdb6201a93c56.jpg";